import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'app/core/models/user';
import { UserService } from 'app/service/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {

  public displayedColumns = ['lastName', 'firstName', 'email', 'role'];
  public dataSourceUsers: MatTableDataSource<User>;
  public users: Array<any>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.refreshFiltersGetData();
  }

  applyFilter(filterValue: string) {
    this.dataSourceUsers.filter = filterValue.trim().toLowerCase();
  }

  async refreshFiltersGetData() {
    this.spinner.show();
    this.users = await this.userService.getUsers().toPromise();
    this.dataSourceUsers = new MatTableDataSource(this.users);
    this.dataSourceUsers.paginator = this.paginator;
    this.dataSourceUsers.sort = this.sort;
    this.spinner.hide();
  } // fin refreshFiltersGetData

}
